module.exports = __webpack_public_path__ + "media/images/icons/userIcon-3e3528e9d1fca542f366a856849aae18.svg";